import React from 'react';
import PropTypes from 'prop-types';
import { SelectFilter } from './Filters/SelectFilter';
import { getActiveRuleSetFromUrl } from '../utils/UrlUtil';
import { i18n } from '../i18n/translate';

export const HeaderMenuAppSwitcher = ({ currentRuleSets = [], menuItems = [], onRedirect }) => {
  const { t } = i18n;

  const APP_OPTIONS = Object.freeze([
    {
      slug: 'train',
      group: 'Train',
      label: t('Train'),
      details: t('Assign and manage learning'),
      icon: 'building-shield',
    },
    {
      slug: 'learn',
      group: 'Learn',
      label: t('Learn'),
      details: t('Complete training assigned to you'),
      icon: 'puzzle',
    },
    {
      slug: 'impact',
      group: 'Impact',
      label: t('Impact'),
      details: t('View the impact of initiatives'),
      icon: 'bullseye-arrow',
    },
    {
      slug: 'promote',
      group: 'Promote',
      label: t('Promote'),
      details: t('Manage marketing programs'),
      icon: 'flag-checkered',
    },
    {
      slug: 'engage',
      group: 'Engage',
      label: t('Engage'),
      details: t('Manage webinars and in-person events'),
      icon: 'microchip',
    },
  ]);

  const activeRuleSet = getActiveRuleSetFromUrl(currentRuleSets);
  const availableApps = APP_OPTIONS.filter(appOption => menuItems.some(menuItem => menuItem.slug === appOption.slug));
  const defaultApp = availableApps.find(appOption => appOption.group === activeRuleSet.interstitial_group);
  const onChange = selectedApp => {
    const menuItem = menuItems.find(menuItem => menuItem.slug === selectedApp.slug);
    if (menuItem) {
      onRedirect(menuItem.target_url);
    }
  };

  // no appswitcher if there is not more that one train role to choose from
  if (availableApps.length < 2) {
    return null;
  } else {
    return (
      <div className="header-menu-app-switcher">
        <SelectFilter
          defaultValue={defaultApp}
          explainerKey="details"
          iconFamily="fi-icon"
          iconKey="icon"
          isClearable={false}
          name="available_apps"
          onChange={onChange}
          options={availableApps}
          showSelected={true}
          valueKey="group"
        />
      </div>
    );
  }
};

HeaderMenuAppSwitcher.propTypes = {
  currentRuleSets: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      interstitial_group: PropTypes.string,
    })
  ),
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      target_url: PropTypes.string,
    })
  ),
  onRedirect: PropTypes.func,
};
